import { Component } from '@angular/core';
import { CMSPortalService } from '../shared/service/cms-portal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-top',
  templateUrl: './top.component.html',
  styleUrls: ['./top.component.css']
})
export class TopComponent {

  public dataAtual = Date();
  public logoUrl = '/assets/img/lib/logoesmpa.png';
  private idPaginaDeAcessibilidade = 766289;

  constructor(private service: CMSPortalService, private router: Router) {
    this.carregarLogoESM();
  }

  carregarLogoESM() {
    this.service.getLogo().subscribe(res => {
      const conteudo = res.conteudo;
      if (conteudo != null && conteudo.base64 != null) {
        this.logoUrl = conteudo.base64;
      }
    });
  }

  abrirAcessibilidade() {
    this.router.navigate(['/pagina', this.idPaginaDeAcessibilidade]);
  }

}
